import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FmlxButton, FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';

function LabwareNameLabel({label, withChevron, isExpanded, maxLabelLength}) {
  const getsubString = (text) => {
    if (text && text?.length > maxLabelLength) {
      return `${text.substring(0, maxLabelLength)}...`;
    }
    return text;
  };
  return (
    <>
      <div className="serial-dilution__tube__deck-selection__description__wrapper">
        <div className="serial-dilution__tube__deck-selection__description--label-plate">
          <FmlxTooltip title={label.labwareName?.length <= maxLabelLength ? '' : label.labwareName}>
            <p
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                margin: 0,
                marginBottom: 5,
              }}
            >
              {getsubString(label.labwareName)}
            </p>
          </FmlxTooltip>
        </div>
        <span className="serial-dilution__tube__deck-selection__description--label-well">
          <FmlxTooltip title={label.wells?.length <= maxLabelLength ? '' : label.wells}>
            <p
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                margin: 0,
              }}
            >
              {getsubString(label.wells)}
            </p>
          </FmlxTooltip>
        </span>
      </div>
      {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
      {withChevron ? <FmlxIcon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size="xs" /> : <></>}
    </>
  );
}

LabwareNameLabel.propTypes = {
  label: PropTypes.string.isRequired,
  maxLabelLength: PropTypes.number.isRequired,
  withChevron: PropTypes.bool,
  isExpanded: PropTypes.bool,
};

LabwareNameLabel.defaultProps = {
  withChevron: false,
  isExpanded: false,
};

function SerialDilutionDeckSelectionButton({label, onClick, labelButton, labelWell, maxLabelLength, isRequired}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const isSourceSelected = labelWell;
  return (
    <div className="serial-dilution__tube__deck-selection">
      <div className="serial-dilution__tube__deck-selection__label">
        {label}
        {isRequired && (
          <FmlxTooltip title="Required" placement="right">
            <span style={{color: 'red'}}>*</span>
          </FmlxTooltip>
        )}
      </div>
      {!isSourceSelected ? (
        <div className={`serial-dilution__tube__deck-selection__unfilled ${label.length < 10 && 'padded'}`}>
          <FmlxButton label={labelButton[0]?.default} size="sm" onClick={onClick} />
        </div>
      ) : (
        <div className="serial-dilution__tube__deck-selection__filled">
          <FmlxButton
            withIcon="start"
            icon={<FmlxIcon name="Pencil" />}
            size="md"
            onlyIcon
            onClick={onClick}
            withTooltip={false}
          />
          <div
            className={`serial-dilution__tube__deck-selection__description ${labelButton?.length > 1 ? 'pointer' : ''}`}
            onClick={() => labelButton.length > 1 && setIsExpanded(!isExpanded)}
          >
            <LabwareNameLabel
              label={labelButton[0]}
              maxLabelLength={maxLabelLength}
              withChevron={labelButton?.length > 1}
              isExpanded={isExpanded}
            />
          </div>
          {isExpanded && (
            <div className="serial-dilution__tube__deck-selection__description accordion">
              {labelButton.map((e, idx) =>
                idx > 0 ? (
                  <LabwareNameLabel
                    label={e}
                    maxLabelLength={maxLabelLength}
                    withChevron={idx === 0 && labelButton?.length > 1}
                    isExpanded
                  />
                ) : (
                  // eslint-disable-next-line react/jsx-no-useless-fragment
                  <></>
                ),
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

SerialDilutionDeckSelectionButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  labelWell: PropTypes.string,
  labelButton: PropTypes.array,
  maxLabelLength: PropTypes.number,
  isRequired: PropTypes.bool,
};

SerialDilutionDeckSelectionButton.defaultProps = {
  labelButton: [],
  labelWell: null,
  maxLabelLength: 40,
  isRequired: false,
};

export default SerialDilutionDeckSelectionButton;
